var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityArrowDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_996",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#d4d4d4",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2838",
    "data-name": "Group 2838",
    transform: "translate(-995 -342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2839",
    "data-name": "Group 2839"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 995, 342)",
    filter: "url(#Path_996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_996-2",
    "data-name": "Path 996",
    transform: "translate(3 1)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 17.5 L 3 17.5 C 1.621500015258789 17.5 0.5 16.37849998474121 0.5 15 L 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 L 15 0.5 C 16.37849998474121 0.5 17.5 1.621500015258789 17.5 3 L 17.5 15 C 17.5 16.37849998474121 16.37849998474121 17.5 15 17.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 1 C 1.897199630737305 1 1 1.897199630737305 1 3 L 1 15 C 1 16.1028003692627 1.897199630737305 17 3 17 L 15 17 C 16.1028003692627 17 17 16.1028003692627 17 15 L 17 3 C 17 1.897199630737305 16.1028003692627 1 15 1 L 3 1 M 3 0 L 15 0 C 16.65685081481934 0 18 1.343149185180664 18 3 L 18 15 C 18 16.65685081481934 16.65685081481934 18 15 18 L 3 18 C 1.343149185180664 18 0 16.65685081481934 0 15 L 0 3 C 0 1.343149185180664 1.343149185180664 0 3 0 Z",
    stroke: "none",
    fill: "#e2e2e2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "chevron-down_1_",
    "data-name": "chevron-down (1)",
    d: "M6,9l4,4,4-4",
    transform: "translate(997 341.667)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityArrowDownIcon);
export default __webpack_public_path__ + "static/media/priority-arrow-down-icon.c893c8c449e0956b05c2f395621e3b78.svg";
export { ForwardRef as ReactComponent };